// 西班牙语
// cSpell:disable
export const h = {
  case: {
    title: "Configuración de información del caso",
    name: "Nombre",
    coverImage: "Imagen de portada",
    describe: "Desc.",
    uploadDesc:
      "Haga clic para cargar la imagen, el tamaño recomendado es (500*375)",
    shareLink: "Configuración del enlace de compartir",
    expiration: "Nunca caduca",
    on: "On",
    off: "Off",
    failureTime: "Tiempo de falla",
    pickDay: "Por favor seleccione una fecha",
    pickerOptions: {
      shortcuts: [
        {
          text: "1 día después",
          value() {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            return date;
          },
        },
        {
          text: "1 semana después",
          value() {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            return date;
          },
        },
        {
          text: "30 días después",
          value() {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
            return date;
          },
        },
      ],
    },
    dateCannotEmpty: "La fecha no puede estar vacía",
    nameCannotEmpty: "¡El nombre no puede estar vacío!",
    descCannotEmpty: "¡La descripción no puede estar vacía!",
    logoSet: "Configuración del logo",
    selectAll: "Seleccionar todo",
    noBrand: "Sin marca todavía",
    openEffect: "Efecto de apertura",
    closeOpenMode: "Ninguna",
    asteroidOpen: "Apertura de asteroides",
    horizontalOpen: "Apertura del crucero horizontal",
    asteroidCruise: "Apertura del crucero de asteroides",
    Crystal: "Apertura de la bola de cristal",
    asteroidScale: "Asteroid Zoom Apertura",
    limitImage:
      "El tamaño de la imagen es demasiado grande, por favor limite el tamaño de la imagen a no más de 4M",
    imageType:
      "Tipo de imagen incorrecto, por favor cargue imágenes en formato png, jpg",
  },
  slide: {
    case: "Casos",
    save: "Guardar",
    view: "Visualización",
    panorama: "Panorama panorámico",
    angleView: "Perspectiva",
    hotspot: "Hotspots",
    music: "Música",
    designer: "Diseñadores",
    beautify: "Embellecer",
  },
  list: {
    title: "Configuración de la lista panorámica",
    draganoramicsort: "Arrastre el panorama para ordenar",
    resetSort: "Reiniciar",
    addPanoramic: "Añadir panorama",
    customThumbnailImages: "Miniaturas personalizadas",
    more: "Más",
    downloadImage: "Descargar imágenes panorámicas",
    replaceImage: "Reemplazar una imagen panorámica",
    downloadImagePackage: "Descargar el paquete Panorama",
    downloadDiagram: "Descargar el diagrama de canales",
    ApplyThumbnailToImage:
      "Aplicar esta miniatura a la imagen de portada del caso",
    VoiceBroadcast: "Información de transmisión de voz",
    restoreImage: "Restaurar imágenes panorámicas",
    uploadImage: "Haga clic para subir la imagen",
    upgradePackage: "Paquete de actualización",
    eidt: "Modificación panorámica",
    name: "Nombre del panorama",
    thumbnail: "Miniaturas",
    enterName: "Introduzca el nombre del panorama",
    uploadDesc:
      "Haga clic para cargar la imagen, el tamaño recomendado es (500*375)",
    confirm: "Determinar",
    cannotEmpty: "El nombre del panorama no puede estar vacío",
    selectToAdd: "Seleccionar Panorama Añadir",
    selectAll: "Seleccionar todas esta página",
    StartAndEnd: "Tiempo de inicio y fin",
    schemeName: "Nombre del esquema de renderizado",
    清晰度: 'Claridad',
    searchThisPlan: "Consulta según este programa",
    search: "Consulta",
    empty: "No hay escenas renderizadas durante el período de tiempo actual",
    dateOptions: {
      shortcuts: [
        {
          text: "hoy",
          value() {
            const end = new Date(
              new Date(new Date().toLocaleDateString()).getTime() +
                24 * 60 * 60 * 1000 -
                1
            );
            const start = new Date(
              new Date(new Date().toLocaleDateString()).getTime()
            );
            return [start, end];
          },
        },
        {
          text: "Hace 3 días",
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
            return [start, end];
          },
        },
        {
          text: "Hace 1 semana",
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            return [start, end];
          },
        },
        {
          text: "Hace 30 días",
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            return [start, end];
          },
        },
        {
          text: "Hace 90 días",
          value() {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            return [start, end];
          },
        },
      ],
    },
    loading: "Cargando...",
    sceneAlreadyExists: "Esta escena ya existe en la lista panorámica actual",
    previewImage: "El panorama actual es una vista previa rápida",
    applyToThumbnail: "Aplicar a las miniaturas",
    delete: "Eliminación",
    content:
      "Al eliminar esta escena, se eliminarán los puntos calientes que apuntan a la escena en otras escenas. ¿Quieres continuar eliminando?",
    captureScreen: "Capturando la pantalla",
    generateScreenshots: "Generar capturas de pantalla",
    thumbnailApply:
      "La imagen en miniatura se aplica correctamente y entrará en vigor después de guardarla",
    atLeastOne: "Por favor, guarde al menos una escena ~",
    downloadCompleted: "¡Descarga completa!",
    fielDownloadFailed: "¡Falló la descarga del archivo!",
    limitImageSize:
      "El tamaño de la imagen es demasiado grande, por favor limite el tamaño de la imagen a no exceder",
    imageType:
      "Tipo de imagen incorrecto, por favor cargue imágenes en formato png, jpg",
    imageAspectRatio: "Por favor, cargue la relación de aspecto como",
    replaceFailed: "El reemplazo falló, por favor inténtelo de nuevo",
    uploadFailed: "La carga falló, por favor inténtelo de nuevo",
    restoreFailed: "Falló la restauración",
    applySuccess: "Aplicado con éxito, entrará en vigencia después de guardar",
    dateCannotEmpty: "La fecha no puede estar vacía",
    全部: 'Todos los',
    快速预览: 'Vista rápida'
  },
  camera: {
    rotationSettings: "Configuración de rotación",
    turnOnRotation: "Abrir la rotación",
    waitTime: "Tiempo de espera (segundos)",
    clickSettings: "Configuración",
    rotationInfoBefore:
      "Confirma que el estado de rotación actual se aplica a la lista de escenas actual",
    rotationInfoAfter: "¿Una escena y guardarla?",
    cameraSettings: "Lentes",
    recently: "Más reciente: campo de vista mínimo cuando la escena se escala",
    initial: "Inicial: ingresa al campo de visión inicial de la escena",
    farthest: "Más lejano: campo de visión máximo cuando la escena se escala",
    recommended:
      "Configuración recomendada: más cercano 70, inicial 95, hasta 125",
    viewingAngle: "Rango de ángulo de visión",
    recentlyt: "Recientemente",
    initialt: "Inicial",
    farthestt: "Más lejano",
    viewInfoFirst: "Usted confirma que el campo de visión actual (reciente:",
    viewInfoSecend: ") Aplicado a la lista actual de escenas",
    viewInfoThird: "¿Una escena y guardarla?",
    inCommonUse: "común",
    reset: "RESET",
    stapleInfo:
      "Guardar el rango actual de ángulos de visión como Mis lentes favoritos",
    commonLenses: "Lentes de uso común",
    systemLens: "Sistema Lente",
    restoreInfo:
      "Restaurar el valor inicial del campo de visión de la escena actual",
    restoreDefault: "Restaurar el éxito predeterminado",
    recommendedLens:
      "El uso exitoso de la lente recomendada entrará en vigor después de guardarla",
    usedLenses:
      "Utilice con éxito las lentes de uso común y surtirá efecto después de guardarlas",
    initialViewpoint:
      "La configuración inicial del ángulo de visión es exitosa y surtirá efecto después de guardarlo",
    setCommonLens: "Configuración de lentes comunes con éxito",
    initialPerspective: "Establecer como vista inicial",
  },
  hotspot: {
    addHotspots: "Añadir",
    clear: "Vaciar",
    clearHotspots: "Borrar puntos de acceso",
    clearHotspotsForCurrentScene:
      "Borrar la lista de puntos de acceso de la escena actual",
    editHotspots: "Editar puntos de acceso",
    return: "Retorno",
    hotspotType: "Tipos de puntos de acceso",
    type: "Tipo",
    hotspotList: "Lista de puntos de acceso de la escena actual",
    all: "Todos los",
    navigation: "Navegación",
    link: "Hipervínculos",
    image: "Imágenes",
    deleteHotspot: "Confirmar la eliminación de este punto de acceso",
    style: "Estilo",
    hotspotName: "Nombre del punto de acceso",
    name: "Nombre",
    enterHotspotName: "Por favor, ingrese el nombre del hotspot",
    targetPanorama: "Objetivo Panorama",
    ok: "Aceptar",
    cancel: "Cancelar",
    edit: "Modificación",
    delete: "Eliminación",
    confirmDelete: "Confirmar la eliminación de este punto de acceso",
    hotspotImage: "Imágenes calientes",
    uploadImage: "Haga clic para subir la imagen",
    editImage: "Modificar la imagen",
    addImage: "Añadir imágenes",
    hotspotAddress: "Dirección de hotspot",
    address: "Dirección",
    targetUrl: "Por favor ingrese la URL de destino",
    videoAddress: "Dirección de vídeo",
    videoUrl: "Por favor introduzca la URL del vídeo",
    targetNoEmpty: "La escena de destino no puede estar vacía",
    noTarget: "No hay escena objetivo aún",
    hotspotNameNoEmpty: "El nombre del punto de acceso no puede estar vacío",
    hotspotDetailNoEmpty:
      "Los detalles del punto de acceso no pueden estar vacíos",
    linkNoEmpty: "La dirección del enlace no puede estar vacía",
    linkIncorrect: "El formato de la dirección del enlace es incorrecto",
    videoNoEmpty: "La dirección del enlace de video no puede estar vacía",
    pleaseUploadImage: "Por favor, cargue primero las imágenes de hotspots",
    limitImage:
      "El tamaño de la imagen es demasiado grande, por favor limite el tamaño de la imagen a no más de 30M",
    uploadFailed: "La carga falló, por favor inténtelo de nuevo",
    uploadSuccessful: "Subida exitosa",
    imageType:
      "Tipo de imagen incorrecto, por favor cargue imágenes en formato png, jpg",
    noHotSpots: "No hay puntos calientes en la escena actual",
    text: "Texto",
    video: "Vídeos",
    hotspotDetail: "Detalles de hotspot",
    detail: "Detalles",
    noOtherScene: "No hay otras escenas aún",
    enterHotspotDetail: "Por favor ingrese los detalles del hotspot",
    videoResources: "Recursos de vídeo",
    clickToSwitch: "Haga clic para cambiar",
    clickUploadVideo: "Haga clic para subir el vídeo",
    videoFormat: "Soporta el formato MP4, hasta 100M máximo",
    enerVideoUrl: "Por favor introduzca la URL del vídeo",
  },
  music: {
    musicSettings: "Configuración de música",
    trialListening: "Audición",
    stopListening: "Dejar de escuchar",
    setMusic: "Configurar la música",
    backgroundMusic: "Música de fondo",
    SystemMusicLibrary: "Biblioteca del sistema",
    selected: "Seleccionado",
    myMusic: "Mi música",
    uploadMusic: "Subir música",
    upgradePackage: "Paquete de actualización",
    uploadAgree: "Suba y acepta",
    disclaimer:
      "Por favor, marque primero el aviso de descarga de responsabilidad",
    musicName: "Por favor introduzca el nombre de la música",
    deleteMusic: "Eliminar música",
    noCustomMusic: "Aún no hay música personalizada",
    onlineMusic: "Música en línea",
    operationProcess: "Proceso de operación",
    oneStep:
      "Encuentre el enlace de audio correcto e ingrese el enlace de audio en el campo de entrada del navegador. Si se puede reproducir o descargar, generalmente es el enlace de audio correcto;",
    twoStep: "Pegue el enlace de audio en el campo de entrada superior;",
    threeStep:
      "Primero haga clic en el botón Aceptar y luego haga clic en Guardar en la esquina superior izquierda.",
    ok: "Determinar",
    placeholderInfo:
      "Ingrese la dirección de la música en línea y garantice la disponibilidad de la música",
    musicAddress: "Por favor ingrese la dirección de la música",
    limitMusic:
      "La dirección de la música es demasiado larga, limite la longitud de la dirección a no más de 150 caracteres",
    saveMusic: "Por favor seleccione la música antes de guardarla",
    linkIncorrect: "El formato de la dirección del enlace es incorrecto",
    musicNonEmpty: "El nombre de la música no puede estar vacío",
    eidtFailed: "Modificación fallida",
    deleteSuccess: "Eliminación exitosa",
    deleteFailed: "Eliminación fallada",
    limitNameCharacter:
      "El nombre del archivo excede los 50 caracteres, por favor modifique antes de cargar",
    limitFileSize:
      "El archivo es demasiado grande, limite el archivo a no más de 10M",
    limitFileType:
      "El formato del archivo es incorrecto, cargue el archivo en formato mp3 o wav",
    limitFileNumber:
      "Demasiados archivos, límite máximo de carga de 30 archivos",
    uploadFailed: "La carga falló, por favor inténtelo de nuevo",
    uploadSuccessful: "Subida exitosa",
    disclaimerInfo: "Descargo de responsabilidad",
  },
  design: {
    designerInfo: "INFORMACIÓN DEL",
    name: "Apellidos",
    enterName: "Introduzca un nombre",
    phone: "Teléfono",
    enterPhone: "Ingrese el teléfono",
    avater: "Avatar",
    uploadImageInfo:
      "Haga clic para cargar la imagen, el tamaño recomendado es (64*64)",
    nameNonEmpty: "¡El nombre no puede estar vacío!",
    phoneNonEmpty: "¡El teléfono no puede estar vacío!",
    phoneNumber: "Por favor, introduzca el número de teléfono correcto!",
    limitImage:
      "El tamaño de la imagen es demasiado grande, por favor limite el tamaño de la imagen a no más de 4M",
    imageType:
      "Tipo de imagen incorrecto, por favor cargue imágenes en formato png, jpg",
  },
  beauty: {
    filterSet: "Configuración del filtro",
    colorSet: "Configuración de color",
    brightness: "Brillo",
    contrastRatio: "Contraste",
    saturation: "Saturación",
    hue: "Hue",
    restoreDefault: "Restaurar por defecto",
    compareOriginalImage: "Compare la imagen original",
    originalImage: "Mantenga presionado para mostrar la imagen original",
    noFilter: "nulo",
    warmYellow: "Amarillo cálido",
    romanticPurple: "Púrpura romántica",
    modernGrey: "Gris moderno",
    restoreSuccessful: "Restaurar el éxito predeterminado",
  },
  tipInfo: {
    tip: "Tips",
    switchNavigation: "Toggle navegación",
    fillCorrectly: "Por favor, después de completar correctamente",
    panoramaEditor: "Editor panorámico",
    editSave: "Por favor edita y guarda",
    viewSave:
      "Todavía tiene información no guardada, por favor guárdela primero y luego verla",
    saveView: "Guardar Ver",
    save: "Guardando",
    saveSuccess: "Guardar con éxito",
    请填写必填项后再进行编辑: "Por favor complete los campos obligatorios antes de editarlos",
  },
  loading: {
    schemeLoading: "Esquema cargando...",
    loadingTitle:
      "Comprometidos a ser la mejor plataforma integrada de diseño del hogar",
    loadingStrives: "Tiangong Smart Home se esfuerza por crear",
  },
  driver: {
    案例详情: "Detalles del caso",
    修改全景名称描述等:
      "Modifique el nombre, la descripción, etc. del panorama, establezca el tiempo de vencimiento del panorama, controle la visualización del logotipo de la marca, etc.",
    下一步: "Siguiente paso",
    上一步: "Paso anterior",
    关闭: "Cierre",
    完成: "Completar",
    全景列表: "Lista panorámica",
    增加删除修改场景:
      "Agregue, elimine, modifique escenas, descargue imágenes panorámicas, reemplace miniaturas panorámicas, modifique nombres panorámicos, etc.",
    视角设置: "Configuración del ángulo de visión",
    设置全景是否开启自动旋转:
      "Establezca si el panorama está activado para rotar automáticamente; Información del ángulo de visión inicial del panorama, etc.",
    热点设置: "Configuración de puntos de acceso",
    增加新的热点或修改已有热点:
      "Agregue nuevos puntos de acceso o modifique los ya existentes.",
    设置音乐: "Configurar la música",
    设计师信息设置: "Configuración de información del diseñador",
    设置设计师头像姓名:
      "Establezca el avatar del diseñador, el nombre, la información de contacto y otra información.",
    美化设置: "Configuración de embellecimiento",
    设置全景滤镜效果:
      "Establecer el efecto de filtro panorámico; Modificar el brillo del color panorámico, el contraste, el tono, etc.",
  },
  video: {
    视频转换: "Conversión de vídeo",
    上传视频: "Subir un vídeo",
    视频格式错误请重新上传视频将转码转码时无法使用全景其他功能:
      "El formato del video es incorrecto, por favor vuelva a cargarlo. El vídeo será transcodificado y no se pueden utilizar otras funciones panorámicas durante la transcodificación.",
    支持MP4格式最大不超过300M: "Soporta el formato MP4, hasta 300M máximo",
    上传视频编码错误请重新上传:
      "Error de codificación de video cargado, por favor vuelva a cargarlo",
    视频转换中: "Conversión de video en curso",
  },
};



// WEBPACK FOOTER //
// ./src/i18n/lan/es.js